import { fillArr, getByOrder } from '@hglobal/fin-ui';

import { Currencies, Currency, Skin, WalletsSkinCollection, WalletType } from '@zeusm/business/core/entities';

// ---------- Currencies ---------

type CurrencyType = 'fiat' | 'crypto' | 'all';

export const currencyCodes = ['USD', 'EUR'];
export const currencyUnicodes = ['$', '€'];
export const coinCodes = ['USDT', 'BTC', 'ETH', 'TRX'];
export const coinUnicodes = ['₮', '₿', 'Ξ', '☉'];
export const allCurrencyCodes = [...currencyCodes, ...coinCodes];
export const allCurrencyUnicodes = [...currencyUnicodes, ...coinUnicodes];
export const networks = ['ERC-20', 'TRC-20'];

export function getCurrencyMock(i: number, type: CurrencyType = 'all'): Currency {
  let codes: string[];
  let unicodes: string[];

  if (type === 'fiat') {
    codes = currencyCodes;
    unicodes = currencyUnicodes;
  } else if (type === 'crypto') {
    codes = coinCodes;
    unicodes = coinUnicodes;
  } else {
    codes = allCurrencyCodes;
    unicodes = allCurrencyUnicodes;
  }

  const code = getByOrder(i, codes);

  return {
    id: i,
    name: code,
    code,
    network: code === 'USDT' ? getByOrder(i, networks) : null,
    image: {
      id: i,
      url: `/assets/images/currencies/${code}.svg`,
      name: code,
    },
    unicode: getByOrder(i, unicodes),
  };
}

export function getFiatsMock(): Currency[] {
  return fillArr(currencyCodes.length, i => getCurrencyMock(i, 'fiat'));
}

export function getCoinsMock(): Currency[] {
  return fillArr(coinCodes.length, i => getCurrencyMock(i, 'crypto'));
}

export function getAllCurrenciesMock(): Currency[] {
  return fillArr(allCurrencyCodes.length, i => getCurrencyMock(i));
}

export function getCurrenciesMock(): Currencies {
  return {
    crypto: getCoinsMock(),
    fiat: getFiatsMock(),
  };
}

// ---------- Skins ---------

export function getCardSkinsMock(count: number): Skin[] {
  return fillArr(count, i => getCardSkinMock(i));
}

export function getCardSkinMock(i: number): Skin {
  return {
    id: (i - 1).toString(),
    url: `/assets/images/cards-business/card.webp`,
  };
}

export function getWalletSkinMock(i: number, type: WalletType): Skin {
  return {
    id: getWalletSkinIdMock(i, type),
    url: `/assets/images/cards-business/${type}-wallet.webp`,
  };
}

export const getWalletSkinsByTypeMock = (type: WalletType, count = 3): Skin[] => fillArr(count, i => getWalletSkinMock(i, type));

export const getWalletSkinsCollectionMock = (): WalletsSkinCollection => {
  return {
    card: getWalletSkinsByTypeMock(WalletType.Card),
    crypto: getWalletSkinsByTypeMock(WalletType.Crypto),
  };
};

export function getWalletSkinIdMock(i: number, type: WalletType): string {
  const skinNumber = i % 3;
  switch (type) {
    case WalletType.Card: {
      return skinNumber.toString();
    }
    case WalletType.Crypto: {
      return (skinNumber + 6).toString();
    }
  }
}
